import { Product, IProductFormState } from '../types/product'
import { MarketplaceProduct } from '../types/marketplace-product'
import { IAddProductToCartInput } from '../types/add-to-cart'
import {
  IAddToCartMutationResult,
  isIAddToCartMutationResult,
} from '../types/cart'
import { IProductValues, IMKPProductValues } from '../types/product-form'
import { createName, createMessage } from './personalise'
import { toUTC } from './date-time'
import { getProductVariant } from './product-form-inputs'
import { IError } from '../types/error'

export const createInput =
  (
    productFormState: IProductFormState,
    product: Product,
    cartId?: string,
    itemId?: string
  ) =>
  (values: IProductValues): IAddProductToCartInput => {
    const isGift: boolean = productFormState.recipientExpanded
    const scheduleDelivery = productFormState.scheduleExpanded
    return {
      input: {
        id: cartId,
        itemId,
        virtualGiftCardItem: {
          id: product.id,
          sku: product.sku,
          value: values.amount.toNumber(),
          recipientDetails: {
            recipientName: createName(isGift, values.personaliseToName),
            senderName: createName(isGift, values.personaliseFromName),
            message: createMessage(
              isGift,
              values.personaliseMessage,
              values.personaliseToName
            ),
            recipientEmail: values.deliveryMethodEmail,
            deliveryMethod: values.deliveryMethod,
            deliveryDate: toUTC(
              scheduleDelivery
                ? values.deliveryDate
                : values.immediateDeliveryDate
            ),
          },
        },
      },
    }
  }

export const promptOnRedirect = (
  formHasChanged: boolean,
  cartOrError?: IAddToCartMutationResult | IError
): boolean =>
  formHasChanged && (!cartOrError || !isIAddToCartMutationResult(cartOrError))

export const createMarketPlaceMutationInput =
  (product: MarketplaceProduct, cartId?: string, itemId?: string) =>
  (values: IMKPProductValues): IAddProductToCartInput => {
    const variant = getProductVariant(product, values)

    // This shouldn't happen but we should probably know if it does
    if (!variant) {
      throw new Error(
        `No variant created from user input for product ${product.id}`
      )
    }

    return {
      input: {
        id: cartId,
        itemId,
        marketplaceItem: {
          sku: variant.sku,
          shopId: product.shop.id,
          // quantity is parsed as a string when the Enter button is pressed. We convert it to Number to avoid errors
          quantity: Number(values.quantity),
        },
      },
    }
  }
